<div *ngIf="checkViewMode('edit')" 
     [class]="'form-group txt_'+getOptionByKey(attribute,'identifier') + ' google-maps-autocomplete'">
  
  <label for="">
    {{ showTitle ? getTitle() : '' }}
    <span class="error-indication" *ngIf="isRequired()">{{getError()}}</span>
    <div *ngIf="getOptionByKey(attribute,'tooltip')"
         class="popover-info"
         [popover]="getOptionByKey(attribute,'tooltip')"
         placement="right"
         container="body"
         triggers="mouseenter:mouseleave">
      <i class="fa fa-question-circle"></i>
    </div>
  </label>

  <div class="input-group position-relative">
    <!-- Input de texto para o Google Maps -->
    <input #googleMapsInput
           type="text"
           class="form-control m-input"
           [class.has-error]="attribute.hasError"
           [(ngModel)]="searchText"
           [placeholder]="getPlaceholder(attribute)"
           [disabled]="getBooleanOptionByKey(attribute,'disabled')"
           [required]="getBooleanOptionByKey(attribute,'required')"
           (input)="onInputChange($event)"
           (focus)="onFocus()"
           (blur)="onBlur()"
           autocomplete="off">
    
    <!-- Indicador de carregamento -->
    <div class="input-group-append" *ngIf="isLoading">
      <span class="input-group-text">
        <i class="fa fa-spinner fa-spin"></i>
      </span>
    </div>
    
    <!-- Botão de limpar -->
    <div class="input-group-append" *ngIf="value && !isLoading">
      <button class="btn btn-outline-secondary" 
              type="button" 
              (click)="clearSelection()"
              title="Limpar seleção">
        <i class="fa fa-times"></i>
      </button>
    </div>

    <!-- Lista de sugestões -->
    <div #autocompleteList 
         class="autocomplete-dropdown" 
         *ngIf="showPredictions && predictions.length > 0">
      <div class="prediction-item" 
           *ngFor="let prediction of predictions; trackBy: trackByPlaceId"
           (click)="selectPlace(prediction)">
        <div class="prediction-main">{{ prediction.structured_formatting?.main_text || prediction.description }}</div>
        <div class="prediction-secondary">{{ prediction.structured_formatting?.secondary_text }}</div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="checkViewMode('view')">
  <p class="component-view">
    <span>{{ getTitle() }}: </span> 
    {{ getValueForView() }}
  </p>
  <div *ngIf="getOptionByKey(attribute,'viewtooltip')" 
       class="popover-info" 
       [popover]="getOptionByKey(attribute,'viewtooltip')"
       placement="right"
       container="body"
       triggers="mouseenter:mouseleave">
    <i class="fa fa-question-circle"></i>
  </div>
</div> 